import { cn } from '../../lib/cn';
import type { MilestoneRow } from '../../customersuccess/framework';

type Props = { milestones?: MilestoneRow[] };

export function SuccessMilestonesPanel({ milestones = [] }: Props) {
  return (
    <div className="space-y-2">
      {milestones.map((m) => (
        <div key={m.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{m.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{m.date}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            m.status === 'achieved' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            m.status === 'in_progress' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
            'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {m.status.replace('_', ' ')}
          </span>
        </div>
      ))}
    </div>
  );
}
